// NOTE: This enum is used to identify the processor of a transaction
// Avoid using non-alphanumeric characters in the enum values
export var AfriexTransactionProcessor;
(function (AfriexTransactionProcessor) {
    AfriexTransactionProcessor["STRIPE"] = "STRIPE";
    AfriexTransactionProcessor["MONO"] = "MONO";
    AfriexTransactionProcessor["OKRA"] = "OKRA";
    AfriexTransactionProcessor["BEYONIC"] = "BEYONIC";
    AfriexTransactionProcessor["CELLULANT"] = "CELLULANT";
    AfriexTransactionProcessor["VFD"] = "VFD";
    AfriexTransactionProcessor["BINANCE"] = "BINANCE";
    AfriexTransactionProcessor["PROVIDUS"] = "PROVIDUS";
    AfriexTransactionProcessor["SHUTTERSCORE"] = "SHUTTERSCORE";
    AfriexTransactionProcessor["ZEEPAY"] = "ZEEPAY";
    AfriexTransactionProcessor["ZENITH"] = "ZENITH";
    AfriexTransactionProcessor["MONCASH"] = "MONCASH";
    AfriexTransactionProcessor["TERRAPAY"] = "TERRAPAY";
    AfriexTransactionProcessor["MFS"] = "MFS";
    AfriexTransactionProcessor["ONAFRIQ"] = "ONAFRIQ";
    AfriexTransactionProcessor["DWOLLA"] = "DWOLLA";
    AfriexTransactionProcessor["DUPLO"] = "DUPLO";
    AfriexTransactionProcessor["CHAPA"] = "CHAPA";
    AfriexTransactionProcessor["YODLEE"] = "YODLEE";
    AfriexTransactionProcessor["PLAID"] = "PLAID";
    AfriexTransactionProcessor["HUB2"] = "HUB2";
    AfriexTransactionProcessor["FAIRMONEY"] = "FAIRMONEY";
    AfriexTransactionProcessor["DLOCAL"] = "DLOCAL";
    AfriexTransactionProcessor["CHECKOUT"] = "CHECKOUT";
    AfriexTransactionProcessor["FINCRA"] = "FINCRA";
    AfriexTransactionProcessor["ZILMONEY"] = "ZILMONEY";
    AfriexTransactionProcessor["MOORWAND"] = "MOORWAND";
    AfriexTransactionProcessor["MONIEPOINT"] = "MONIEPOINT";
    AfriexTransactionProcessor["ALPAY"] = "ALPAY";
    AfriexTransactionProcessor["PAYSTACK"] = "PAYSTACK";
    AfriexTransactionProcessor["ECSA"] = "ECSA";
    AfriexTransactionProcessor["WAPIPAY"] = "WAPIPAY";
    AfriexTransactionProcessor["KORAPAY"] = "KORAPAY";
    AfriexTransactionProcessor["JUICYWAY"] = "JUICYWAY";
    AfriexTransactionProcessor["BRIDGECARD"] = "BRIDGECARD";
    AfriexTransactionProcessor["BRIDGEXYZ"] = "BRIDGEXYZ";
    AfriexTransactionProcessor["PAYAZA"] = "PAYAZA";
    AfriexTransactionProcessor["FLICK"] = "FLICK";
    AfriexTransactionProcessor["TRICE"] = "TRICE";
    AfriexTransactionProcessor["PAWAPAY"] = "PAWAPAY";
    AfriexTransactionProcessor["INTERAC"] = "INTERAC";
    AfriexTransactionProcessor["BLAAIZ"] = "BLAAIZ";
    AfriexTransactionProcessor["SASAPAY"] = "SASAPAY";
    AfriexTransactionProcessor["WORLDPAY"] = "WORLDPAY";
    AfriexTransactionProcessor["NOAH"] = "NOAH";
    AfriexTransactionProcessor["MIDEN"] = "MIDEN";
    AfriexTransactionProcessor["FLUTTERWAVE"] = "FLUTTERWAVE";
    AfriexTransactionProcessor["GIB"] = "GIB";
    AfriexTransactionProcessor["EZREMIT"] = "EZREMIT";
    AfriexTransactionProcessor["NAIRAGRAM"] = "NAIRAGRAM";
    AfriexTransactionProcessor["CHOICEBANK"] = "CHOICEBANK";
    AfriexTransactionProcessor["LIGHTNET"] = "LIGHTNET";
    AfriexTransactionProcessor["BREX"] = "BREX";
    AfriexTransactionProcessor["UTILA"] = "UTILA";
    AfriexTransactionProcessor["NOMBA"] = "NOMBA";
    AfriexTransactionProcessor["MAGMA_ONEPAY"] = "MAGMA_ONEPAY";
    AfriexTransactionProcessor["BALAD"] = "BALAD";
    AfriexTransactionProcessor["PEOPLES_GROUP"] = "PEOPLES_GROUP";
    AfriexTransactionProcessor["GLOBUS_BANK"] = "GLOBUS_BANK";
    AfriexTransactionProcessor["GPAY"] = "GPAY";
    AfriexTransactionProcessor["TEMBO"] = "TEMBO";
    AfriexTransactionProcessor["UBA"] = "UBA";
    // The Pan-African Payment and Settlement System, an ISO 20022 cross-border
    // rail reached over a site-to-site VPN. Outbound (payout) only.
    AfriexTransactionProcessor["PAPSS"] = "PAPSS";
    // Jenzy Hermes — MWK payouts to Malawi over mobile money (Airtel Money,
    // TNM Mpamba) and bank account transfer. Outbound (payout) only.
    AfriexTransactionProcessor["JENZY"] = "JENZY";
    // Moolre — GHS virtual accounts (business + business-customer, via API),
    // mobile money (MTN, Telecel, AT) collections, and mobile money +
    // Instant Bank Transfer payouts for Ghana.
    AfriexTransactionProcessor["MOOLRE"] = "MOOLRE";
    // Bank payouts to Zambia, Tanzania, South Africa. See
    // packages/server/src/lib/processors/transactionNodes/novac/NovacNode.ts.
    AfriexTransactionProcessor["NOVAC"] = "NOVAC";
    AfriexTransactionProcessor["DANDELION"] = "DANDELION";
    AfriexTransactionProcessor["PAYSEND"] = "PAYSEND";
    // One Liquidity: liquidity provider for the admin OTC desk (NGN to USDT/USDC),
    // also offering NGN collections and bank payouts. See
    // packages/server/src/lib/clients/liquidityProviders/oneLiquidity.
    AfriexTransactionProcessor["ONE_LIQUIDITY"] = "ONE_LIQUIDITY";
    // NOTE: This is a processor for the Afriex API, our biz api
    AfriexTransactionProcessor["AFRIEX_API"] = "AFRIEX_API";
    AfriexTransactionProcessor["SYSTEM"] = "SYSTEM";
    // In-house processor emulator for business sandbox testing. Registered only
    // outside production, and never configured on a currency document: the
    // selectors route to it from the `sandboxEmulator.mode` setting. See
    // packages/docs/Sandbox-Simulators.md.
    AfriexTransactionProcessor["EMULATOR"] = "EMULATOR";
    // CARD Vaulting and Tokenization Processors
    AfriexTransactionProcessor["BASISTHEORY"] = "BASISTHEORY";
    AfriexTransactionProcessor["AFRIEX_CDE_VAULT"] = "AFRIEX_CDE_VAULT";
    // This is a processor enum used to identify transactions that have contexts missing
    // It shouldn't be used for any other purpose in the system
    // using it for any other purpose will be considered a bug
    AfriexTransactionProcessor["UNKNOWN"] = "UNKNOWN";
})(AfriexTransactionProcessor || (AfriexTransactionProcessor = {}));
/**
 * Processors that must never be configured on a business (`business`) or public
 * API (`api`) corridor of a currency document.
 *
 * `AFRIEX_API` is the rail that pushes a transaction through Afriex's own
 * business API. Routing a business or API corridor to it would send that
 * traffic straight back into the API it arrived from, so it is retail-only.
 * The transaction node already refuses any non-`AFRIEX` userType, which means a
 * corridor configured this way does not mis-route: it fails to resolve a
 * processor at all. This list is what stops it being configured in the first
 * place, in the admin dropdowns and in the PATCH schema behind them.
 *
 * Deliberately does NOT include `SYSTEM`, which looks similar but is the
 * opposite case: business scheduled and on-request settlements route through it
 * on purpose.
 */
export const BUSINESS_RESTRICTED_PROCESSORS = [AfriexTransactionProcessor.AFRIEX_API];
/**
 * Processors that must never be configured on any corridor of a currency
 * document, retail included, and are left out of every admin processor list.
 *
 * `EMULATOR` is routed to from deployment config, not from the currency
 * document. Keeping it off the document means a document copied from a
 * sandbox environment into production cannot carry it across.
 */
export const UNCONFIGURABLE_PROCESSORS = [AfriexTransactionProcessor.EMULATOR];
//# sourceMappingURL=AfriexTransactionProcessor.js.map